// context/SettingsContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const SettingsContext = createContext();

const defaultSettings = {
    calcMode: "best1",
    category: "all",
    selectedCodex: [],
    selectedDisciplines: ["SL", "GS", "SG", "CR"],
    modeBestX: "per-discipline",
    calcPerDiscipline: {
        SL: "best1",
        GS: "best1",
        SG: "best1",
        CR: "best1",
    },
};

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(() => {
        const saved = localStorage.getItem("settings");
        if (!saved) return defaultSettings;

        try {
            const parsed = JSON.parse(saved);
            // 🔥 merge pour ne jamais perdre les nouveaux champs
            return {
                ...defaultSettings,
                ...parsed,
                calcPerDiscipline: {
                    ...defaultSettings.calcPerDiscipline,
                    ...(parsed.calcPerDiscipline || {}),
                },
            };
        } catch (e) {
            console.warn("Settings illisibles, reset aux defaults");
            return defaultSettings;
        }
    });

    const updateCalc = (discipline, value) => {
        setSettings((prev) => {
            const next = {
                ...prev,
                calcPerDiscipline: {
                    ...prev.calcPerDiscipline,
                    [discipline]: value,
                },
            };
            console.log("🔁 updateCalc ->", discipline, value, next.calcPerDiscipline);
            return next;
        });
    };

    useEffect(() => {
        localStorage.setItem("settings", JSON.stringify(settings));
        console.log("💾 settings sauvegardés :", settings);
    }, [settings]);

    return (
        <SettingsContext.Provider value={{ settings, setSettings, updateCalc }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
